<template>
  <div class="unlabelled-card">
    <v-card>
      <v-overlay :value="isPending">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-overlay absolute :value="labelizationStatus ==='labelized'">
        <v-btn rounded color="success" fab dark large>
          <v-icon large dark>mdi-check</v-icon>
        </v-btn>
      </v-overlay>
      <v-overlay absolute :value="labelizationStatus ==='deleted'">
        <v-btn rounded color="red" fab dark large>
          <v-icon large dark>mdi-delete</v-icon>
        </v-btn>
      </v-overlay>
      <v-card-title>
        <v-row>
          <v-col class="ma-1">
            <span>{{unlabelled.label}}</span>
            <v-btn icon @click="dialog = true">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col align="end">
            <v-btn
              class="ma-1"
              color="warning"
              @click="selectItem(unlabelled.uuid, '', 'EXCLUDED')"
            >Exclude</v-btn>
            <v-btn class="ma-1" color="red" dark @click="deleteUnlabelled">Delete</v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle>
        <v-chip
          class="ma-1"
        >Kitchen | {{getElementByUuid(unlabelled.last_seen.kitchen_uuid, kitchens).id}}</v-chip>
        <v-chip
          class="ma-1"
        >Concept | {{getElementByUuid(unlabelled.last_seen.concept_uuid, concepts).label}}</v-chip>
        <v-chip
          class="ma-1"
        >Platform | {{getElementByUuid(unlabelled.last_seen.platform_uuid, platforms).label}}</v-chip>
        <v-chip
          class="ma-1"
        >Parent | {{getParentLabel(unlabelled.parent_uuid, unlabelled.parent_type)}}</v-chip>
        <v-chip
          class="ma-1"
        >Parent Type | {{unlabelled.parent_type ? unlabelled.parent_type : "None"}}</v-chip>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col align="center" cols="12" sm="8">
            <v-list dense>
              <v-list-item v-for="item in unlabelled.best_matches" :key="item.title">
                <v-list-item-content class="pa-0">
                  <v-list-item-title v-text="item.label"></v-list-item-title>
                  <v-row class="d-flex align-center pa-0">
                    <v-col cols="2" class="py-0">{{Math.ceil(item.score * 100)}} %</v-col>
                    <v-col
                      cols="6"
                      align="start"
                      class="py-0"
                    >{{getElementLabel(item.uuid, item.type)}}</v-col>
                    <v-col cols="2" class="py-0">{{item.type}}</v-col>
                    <v-col cols="2" class="py-0">
                      <v-btn icon @click="selectItem(unlabelled.uuid, item.uuid, item.type)">
                        <v-icon color="primary" small>mdi-send</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col align="center" cols="12" sm="4">
            <v-autocomplete
              v-model="selectedCombo"
              :items="filteredCombos"
              item-text="label"
              label="Combos"
              hide-selected
              return-object
              clearable
            ></v-autocomplete>
            <v-autocomplete
              v-model="selectedMenuItem"
              :items="filteredMenuItems"
              item-text="label"
              label="Menu Items"
              hide-selected
              return-object
              clearable
            ></v-autocomplete>
            <v-divider class="mt-1 mb-3"></v-divider>
            <div>
              <p>
                Selected: {{selectedItem.item.label}}
                <v-btn
                  icon
                  v-if="selectedItem.display"
                  @click="selectItem(unlabelled.uuid, selectedItem.item.uuid, selectedItem.type)"
                >
                  <v-icon color="primary" small>mdi-send</v-icon>
                </v-btn>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog max-width="500px" v-model="dialog">
      <v-card>
        <v-card-title class>Details</v-card-title>
        <v-card-text>
          <v-text-field label="UUID" :value="unlabelled.uuid" readonly></v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    unlabelled: { type: Object },
    concepts: { type: Array },
    kitchens: { type: Array },
    platforms: { type: Array },
    combos: { type: Array },
    menuItems: { type: Array },
    labelizationStatuses: { type: Object },
  },
  data: () => {
    return {
      dialog: false,
      selectedCombo: null,
      selectedMenuItem: null,
    };
  },
  watch: {
    selectedCombo() {
      if (this.selectedCombo && this.selectedMenuItem) {
        this.selectedMenuItem = null;
      }
    },
    selectedMenuItem() {
      if (this.selectedMenuItem && this.selectedCombo) {
        this.selectedCombo = null;
      }
    },
  },
  computed: {
    filteredCombos() {
      return this.combos.filter((combo) => {
        return combo.concept_uuids.includes(
          this.unlabelled.last_seen.concept_uuid
        );
      });
    },
    filteredMenuItems() {
      return this.menuItems.filter((menuItem) => {
        return menuItem.concept_uuids.includes(
          this.unlabelled.last_seen.concept_uuid
        );
      });
    },
    selectedItem() {
      if (this.selectedCombo) {
        return { item: this.selectedCombo, type: "COMBO", display: true };
      } else if (this.selectedMenuItem) {
        return {
          item: this.selectedMenuItem,
          type: "MENU_ITEM",
          display: true,
        };
      } else {
        return {
          item: { label: "No Item selected" },
          type: "None",
          display: false,
        };
      }
    },
    isPending() {
      if (this.unlabelled.uuid in this.labelizationStatuses) {
        return this.labelizationStatuses[this.unlabelled.uuid].pending;
      }
      return false;
    },
    labelizationStatus() {
      if (this.unlabelled.uuid in this.labelizationStatuses) {
        return this.labelizationStatuses[this.unlabelled.uuid].status;
      }
      return "";
    },
  },
  methods: {
    getElementByUuid(uuid, list) {
      return list.find((obj) => obj.uuid === uuid);
    },
    getElementLabel(uuid, type) {
      if (type === "MENU_ITEM") {
        let found = this.getElementByUuid(uuid, this.menuItems);
        return found ? found.label : "Unknown";
      } else if (type === "COMBO") {
        let found = this.getElementByUuid(uuid, this.combos);
        return found ? found.label : "Unknown";
      }
      return "Unknown";
    },
    getParentLabel(uuid, type) {
      if (!uuid || !type) {
        return "None";
      }
      return this.getElementLabel(uuid, type);
    },
    selectItem(unlabelledUuid, itemUuid, itemType) {
      this.$emit("selectItem", unlabelledUuid, itemUuid, itemType);
    },
    deleteUnlabelled() {
      this.$emit("deleteUnlabelled", this.unlabelled.uuid);
    },
  },
};
</script>
